import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

export const UPSERT_LEAFBUYER_MARKETING_CONFIG = 'api/leafbuyer-marketing-config/upsert';
export const GET_LEAFBUYER_MARKETING_CONFIG = 'api/leafbuyer-marketing-config';
export const TEST_LEAFBUYER_MARKETING_CONFIG = 'api/leafbuyer-marketing-config/test';

export type LeafbuyerSMSMarketingConfig = {
  ClientId: string;
  FriendlyName: string;
  IsDeleted: boolean;
  LeafbuyerSMSMarketingConfigId?: number;
};

export type UpsertLeafbuyerMarketingConfigResult = {
  data: LeafbuyerSMSMarketingConfig;
  message?: string;
  success: boolean;
};

export type TestLeafbuyerMarketingConfigPayload = {
  ClientId: string;
  LeafbuyerSMSMarketingConfigId?: number;
  PhoneNumber: string;
};

export function useUpsertLeafbuyerMarketingConfigMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: LeafbuyerSMSMarketingConfig) =>
      fetchData<UpsertLeafbuyerMarketingConfigResult>(UPSERT_LEAFBUYER_MARKETING_CONFIG, {
        method: 'POST',
        ...request,
      }),
    onSuccess: () => {
      // Invalidate the query to refetch the updated data
      void queryClient.invalidateQueries({
        queryKey: leafbuyerMarketingConfigsQueryKey,
      });
    },
  });
}

export const leafbuyerMarketingConfigsQueryKey = ['leafbuyerMarketingConfigs'];

export function useGetLeafbuyerMarketingConfigsQuery() {
  return useQuery({
    queryKey: leafbuyerMarketingConfigsQueryKey,
    queryFn: () =>
      fetchData<LeafbuyerSMSMarketingConfig[]>(`${GET_LEAFBUYER_MARKETING_CONFIG}`, {
        method: 'POST',
      }),
    staleTime: Infinity,
  });
}

export function useTestLeafbuyerMarketingConfigMutation() {
  return useMutation({
    mutationFn: (payload: TestLeafbuyerMarketingConfigPayload) =>
      fetchData<void>(`${TEST_LEAFBUYER_MARKETING_CONFIG}`, {
        method: 'POST',
        ...payload,
      }),
  });
}
